<template>
  <div
    id="commercial-dashboard-root"
    class="h-full w-full min-w-0 flex-1 overflow-y-auto bg-n-background"
  />
</template>
